import React from 'react';
import SegmentedControl from 'Components/DesignSystem/SegmentedControl/SegmentedControl';

export type TFilterSwitchProps = {
    id: string;
    labels: string[];
    selectedFilter: string;
    setSelectedFilter: React.Dispatch<React.SetStateAction<string>>;
}

/**
 * The Attribute / List switch above the Multi-choice panel's values.
 *
 * A hand-rolled pill row before — buttons on a sunken track, which is exactly what DS
 * `SegmentedControl` is. The DS version is a real radiogroup: one tab stop, arrow keys
 * move and select. The old one was a row of independent buttons with no grouping, so a
 * keyboard user tabbed through each pill and nothing announced them as alternatives.
 *
 * The per-index testids are preserved verbatim — `ConfigurationFilter.test.tsx` and
 * `MultiChoiceConfigurationNew.test.tsx` both drive the switch through them.
 */
const ConfigurationFilter = ({ id, labels, selectedFilter, setSelectedFilter }: TFilterSwitchProps) => {
    const capitalize = (str: string) => `${str.charAt(0).toUpperCase()}${str.slice(1)}`;

    return (
        <SegmentedControl
            id={id}
            data-testid={id}
            ariaLabel="Value source"
            value={selectedFilter}
            onChange={(next) => setSelectedFilter(String(next))}
            options={labels.map((label, index) => ({
                id: label,
                label: capitalize(label),
                'data-testid': `components-configurationfilter-button-1-${index}`,
            }))}
        />
    );
};

export default ConfigurationFilter;
